import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "fileType-excel",
  "use": "fileType-excel-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"fileType-excel\"><defs><symbol id=\"fileType-excel_file-excel\" data-name=\"file-excel\" viewBox=\"0 0 20 20\"><path d=\"M15.77,0H0V20H20V4.23Zm-3.9,14.46L10,11.25a3.32,3.32,0,0,1-.19-.44h0s-.07.18-.2.45l-2,3.2H6.25l2.83-4.28L6.48,5.94H7.83L9.51,8.89a5.85,5.85,0,0,1,.3.61h0a7,7,0,0,1,.32-.63l1.76-2.92h1.26l-2.66,4.23,2.7,4.3Zm3.9-10.09V.28l4.08,4.08Z\" fill=\"#009943\" /></symbol></defs><title>fileType-excel</title><g id=\"fileType-excel_图层_2\" data-name=\"图层 2\"><g id=\"fileType-excel_图层_1-2\" data-name=\"图层 1\"><use width=\"20\" height=\"20\" xlink:href=\"#fileType-excel_file-excel\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/fileType-excel.svg
// module id = h0oj
// module chunks = 264